module.exports = __webpack_public_path__ + "static/media/home_bg_wide.7a11dd8c.png";